import { FunctionComponent } from "react";
import { useLocation } from "react-router-dom";
import { PageContainerProps } from "./page-container.types";
import { Header } from "./shared/header";
import { Toaster } from "@/components/ui/toaster";

export const PageContainer: FunctionComponent<PageContainerProps> = ({
  children,
}) => {
  const router = useLocation();

  const validationPath =
    router.pathname !== "/signin" &&
    router.pathname !== "/po-agent" &&
    !router.pathname.includes("/external/") &&
    !router.pathname.startsWith("/vision/proposta");

  return (
    <div className="grid h-screen grid-rows-[auto_1fr] grid-cols-[minmax(0,1fr)]">
      {validationPath && <Header />}

      <main className="row-start-2">
        <div className="h-full mx-auto mb-8">{children}</div>
      </main>

      <Toaster />
    </div>
  );
};
